export default __webpack_public_path__ + "static/media/list.6ba733c8.svg";